import { render, staticRenderFns } from "./BillingSetting.vue?vue&type=template&id=045d4a60&"
import script from "./BillingSetting.vue?vue&type=script&lang=js&"
export * from "./BillingSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports